class NewsletterPopup {
  constructor() {
    console.log('NewsletterPopup initializing...');
    this.trigger = document.querySelector('.newsletter-trigger');
    this.popup = document.querySelector('.newsletter-popup');
    this.overlay = document.querySelector('.newsletter-overlay');
    this.closeButton = document.querySelector('.newsletter-popup__close');
    this.form = document.querySelector('.newsletter-popup__form');
    
    if (!this.trigger || !this.popup) {
      console.warn('Missing required elements:', {
        trigger: !!this.trigger,
        popup: !!this.popup
      });
      return;
    }
    console.log('NewsletterPopup elements found, initializing...');
    
    this.init();
  }

  init() {
    if (!this.trigger || !this.popup) return;

    // Show/hide popup
    this.trigger.addEventListener('click', (e) => {
      console.log('Trigger clicked');
      e.stopPropagation();
      this.togglePopup();
    });
    this.closeButton.addEventListener('click', () => this.hidePopup());

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!this.popup.contains(e.target) && !this.trigger.contains(e.target)) {
        this.hidePopup();
      }
    });

    // Handle form submission
    if (this.form) {
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    // Check if user has already subscribed
    if (localStorage.getItem('newsletterSubscribed')) {
      this.trigger.style.display = 'none';
    }
  }

  togglePopup() {
    const isHidden = this.popup.getAttribute('aria-hidden') === 'true';
    this.popup.setAttribute('aria-hidden', !isHidden);
    this.overlay.setAttribute('aria-hidden', !isHidden);
    this.trigger.setAttribute('aria-expanded', isHidden);
  }

  hidePopup() {
    this.popup.setAttribute('aria-hidden', 'true');
    this.overlay.setAttribute('aria-hidden', 'true');
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  async handleSubmit(e) {
    const form = e.target;
    const submitButton = form.querySelector('.newsletter-popup__submit');

    try {
      submitButton.disabled = true;
      submitButton.textContent = 'Signing Up...';

      // Store subscription status
      localStorage.setItem('newsletterSubscribed', 'true');
      
      // Hide the trigger button
      this.trigger.style.display = 'none';

      // Close popup after delay
      setTimeout(() => this.hidePopup(), 3000);

    } catch (error) {
      console.error('Subscription error:', error);
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = 'Sign Up';
    }
  }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  new NewsletterPopup();
}); 